import {HammerGestureConfig} from '@angular/platform-browser';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class HammerConfig extends HammerGestureConfig {

  overrides: any = {
    swipe: {
      direction: Hammer.DIRECTION_ALL,
      threshold: 5
    } // override default settings
  };
}